import "babel-polyfill";

import "./libs/jquery"
// import "lottie-web"

import "./libs/lottie"
import "./libs/slick"

import {binder, fwa} from "./libs/binder"
import {detectDevicesAndBrowser} from "./modules/module"
import "./libs/jcf"
import {initJCFSelect} from "./modules/initJCFSelect"
import {toggleMainNavigation} from "./modules/toggle-main-navigation"
import {testimonialsSlider} from "./modules/testimonialsSlider"
import {accordion} from "./modules/accordion"
import {tabs} from "./modules/tabs";
import {productsSlider} from "./modules/productsSlider";
import {contentVideo} from "./modules/contentVideo";
import {printArticle} from "./modules/printArticle";
import {stepsAnimation} from "./modules/stepsAnimation";
import {cellAnimations} from "./modules/cellAnimations";
import {iconsAnimations} from "./modules/iconsAnimations";
import {featuredIconsAnimations} from "./modules/featuredIconsAnimations";
import {historySlider} from "./modules/historySlider";
import {hbsptFormInputAnimation} from "./modules/hbsptFormInputAnimation";
import {popupOpen} from './modules/popupOpen'

binder({
    bounds: {
        "html": detectDevicesAndBrowser,
        "select": initJCFSelect,
        ".burger-btn": toggleMainNavigation,
        ".testimonials-slider": testimonialsSlider,
        ".accordion": accordion,
        ".tabs-holder": tabs,
        ".products-slider": productsSlider,
        ".video-holder": contentVideo,
        ".print-ico": printArticle,
        ".steps-list": stepsAnimation,
        // ".cell-animations": cellAnimations,
        ".info-items .icon": iconsAnimations,
        ".feature-links": featuredIconsAnimations,
        ".history-slider": historySlider,
        ".hbspt-form": hbsptFormInputAnimation,
        ".popup-opener": popupOpen,
    },
    runTests: false
});


// WEBPACK FOOTER //
// ./assets/js/global.js